export default {
  agency_key: '',
  mode: '',
  beian: '',
  beian_gn: '',

  address: '上海市徐汇区普天信息产业园A7栋709室',
  uc_host: 'http://i.drumplus.cn',
  site_host: 'http://www.drumplus.cn',
  chat_url: 'javascript:window.open(\'https://wpa.qq.com/msgrd?v=3&uin=695452366&site=qq&menu=yes\', \'_blank\', \'height=502, width=644,toolbar=no,scrollbars=no,menubar=no,status=no\');',
  special_url: '/',
  site_title: '东传科技 专业公众号增粉平台',
  welcome_title: '东传科技 专业公众号增粉平台！',
  site_short_title: '东传科技',
  site_subtitle: '专业微信公众号引流平台',
  company_name: '东传科技',
  copyright: '© 2019 东传科技',
  logo: 'https://xinmeibao.oss-cn-hangzhou.aliyuncs.com/drumplus/images/logo-blue.svg',
  favicon: 'https://xinmeibao.oss-cn-hangzhou.aliyuncs.com/drumplus/images/favicon.ico',
  payment: '',
  qq: '2279099005',
  tel: '15906729802',
  company_account_id: '1001294809300024043',
  company_bank: '中国工商银行桂林路支行',
  company_bank_name: '上海东传网络科技有限公司',
  alipay_account_id: '',
  alipay_name: '东传科技',
  alipay_pic: '',
  section_id: 0,
  belonger_id: 0,
}



//////////////////
// WEBPACK FOOTER
// ./project_config.js
// module id = null
// module chunks = 